import { render, staticRenderFns } from "./RecentRecordings.vue?vue&type=template&id=13455c95&scoped=true"
import script from "./RecentRecordings.vue?vue&type=script&lang=js"
export * from "./RecentRecordings.vue?vue&type=script&lang=js"
import style0 from "./RecentRecordings.vue?vue&type=style&index=0&id=13455c95&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13455c95",
  null
  
)

export default component.exports